var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-no-wrap gap-3" },
    [
      _c("FormGroup", {
        attrs: {
          placeholder: "Search for job posting",
          debounceTime: 500,
          type: "search",
          iconStyle: "customIcon",
          inputClass: "customFormInput postingSize",
        },
        model: {
          value: _vm.jobTitle,
          callback: function ($$v) {
            _vm.jobTitle = $$v
          },
          expression: "jobTitle",
        },
      }),
      !_vm.isContractor
        ? _c(
            "FormGroup",
            [
              _c("ContractorsMultiselect", {
                attrs: {
                  contractorsConditions: _vm.contractorsConditions,
                  placeholder: "Resources",
                  debounceTime: 1000,
                  getParentcontainerStyle: "customWidthMax smallHeight",
                },
                model: {
                  value: _vm.contractorsIds,
                  callback: function ($$v) {
                    _vm.contractorsIds = $$v
                  },
                  expression: "contractorsIds",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.isAdmin
        ? _c(
            "FormGroup",
            [
              _c("ManagersMultiselect", {
                attrs: {
                  placeholder: "Managers",
                  getParentcontainerStyle: "customWidthMax smallHeight",
                  debounceTime: 1000,
                },
                model: {
                  value: _vm.managersIds,
                  callback: function ($$v) {
                    _vm.managersIds = $$v
                  },
                  expression: "managersIds",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "FormGroup",
        [
          _c("ProfileCountrySelect", {
            attrs: {
              multiple: true,
              placeholder: "Countries",
              getcontainerStyle: "smallHeight",
              debounceTime: 1000,
            },
            model: {
              value: _vm.countries,
              callback: function ($$v) {
                _vm.countries = $$v
              },
              expression: "countries",
            },
          }),
        ],
        1
      ),
      _c("RegionInput", {
        attrs: {
          countries: _vm.countries,
          iconStyle: "customIcon",
          inputClass: "customFormInput",
          getcontainerStyle: "smallHeight",
          multiple: "",
          debounceTime: 1000,
        },
        model: {
          value: _vm.states,
          callback: function ($$v) {
            _vm.states = $$v
          },
          expression: "states",
        },
      }),
      _c(
        "FormGroup",
        [
          _c("PostingCityMultiselect", {
            attrs: {
              country: _vm.countriesNames,
              state: _vm.statesNames,
              placholder: "Cities",
              debounceTime: 1000,
              getcontainerStyle: "smallHeight",
            },
            model: {
              value: _vm.cities,
              callback: function ($$v) {
                _vm.cities = $$v
              },
              expression: "cities",
            },
          }),
        ],
        1
      ),
      _c(
        "FormGroup",
        [
          _c("SkillsMultiselect", {
            attrs: {
              placeholder: "Skill",
              debounceTime: 1000,
              getcontainerStyle: "smallHeight",
            },
            model: {
              value: _vm.skillsIds,
              callback: function ($$v) {
                _vm.skillsIds = $$v
              },
              expression: "skillsIds",
            },
          }),
        ],
        1
      ),
      _c(
        "FormGroup",
        [
          _c("IndustriesMultiselect", {
            attrs: {
              placeholder: "Industry",
              debounceTime: 1000,
              getcontainerStyle: "smallHeight",
            },
            model: {
              value: _vm.industries,
              callback: function ($$v) {
                _vm.industries = $$v
              },
              expression: "industries",
            },
          }),
        ],
        1
      ),
      !_vm.isContractor
        ? _c(
            "FormGroup",
            [
              _c("PostedAtSelect", {
                attrs: {
                  placeholder: "Posted",
                  getcontainerStyle: "smallHeight",
                },
                model: {
                  value: _vm.postedAt,
                  callback: function ($$v) {
                    _vm.postedAt = $$v
                  },
                  expression: "postedAt",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.displayCompaniesFilter && _vm.currentUserId
        ? _c(
            "FormGroup",
            [
              _c("ContractorCompaniesMultiselect", {
                attrs: {
                  getcontainerStyle: "smallHeight",
                  currentUserId: _vm.currentUserId,
                  placeholder: "Companies",
                },
                model: {
                  value: _vm.companies,
                  callback: function ($$v) {
                    _vm.companies = $$v
                  },
                  expression: "companies",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c(
            "p",
            { staticClass: "text-gray-400 text-xs mt-2 mr-2 w-max-content" },
            [_vm._v(" Duration in days ")]
          ),
          _c(
            "FormGroup",
            [
              _c("InputRangeFilter", {
                attrs: {
                  minValue: _vm.minDuration,
                  maxValue: _vm.maxDuration,
                  inputClasses: "pl-8 w-24",
                  iconStyle: "customIcon",
                  inputClass: "customFormInput",
                },
                on: {
                  "update:minValue": function ($event) {
                    _vm.minDuration = $event
                  },
                  "update:min-value": function ($event) {
                    _vm.minDuration = $event
                  },
                  "update:maxValue": function ($event) {
                    _vm.maxDuration = $event
                  },
                  "update:max-value": function ($event) {
                    _vm.maxDuration = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("UiButtonMessage", {
        attrs: {
          buttonClass: "customAdd",
          buttonText: "Reset",
          textClass: "customText customOnlyText",
        },
        on: { click: _vm.handleReset },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }